import script from "./couponList.vue?vue&type=script&setup=true&lang=js"
export * from "./couponList.vue?vue&type=script&setup=true&lang=js"

import "./couponList.vue?vue&type=style&index=0&id=3236575a&lang=less&scoped=true"

import exportComponent from "/root/workspace/dsx-frontend_gib7/h5/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3236575a"]])

export default __exports__